module.exports = __webpack_public_path__ + "img/4.9a4caa19.jpeg";